import { render, staticRenderFns } from "./SimulacaoVenda.vue?vue&type=template&id=c8d90d08&scoped=true"
import script from "./SimulacaoVenda.vue?vue&type=script&lang=js"
export * from "./SimulacaoVenda.vue?vue&type=script&lang=js"
import style0 from "./SimulacaoVenda.vue?vue&type=style&index=0&id=c8d90d08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d90d08",
  null
  
)

export default component.exports